// extracted by mini-css-extract-plugin
export default {"outer":"PopUp_outer__oZU0L","closeIcon":"PopUp_closeIcon__PXi9f","content":"PopUp_content__TA3m8","htmlDescription":"PopUp_htmlDescription__AvLSZ"};